(()=>{
 if(!document.body.classList.contains('nov-business'))return;
 document.querySelectorAll('.bs-carousel-wrap').forEach(wrap=>{
  const track=wrap.querySelector('[data-bs-carousel]'),previous=wrap.querySelector('.bs-carousel-prev'),next=wrap.querySelector('.bs-carousel-next');
  if(!track||!previous||!next)return;
  const update=()=>{previous.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;};
  const move=direction=>{const card=track.firstElementChild;if(!card)return;const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap||0);track.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
  track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
 });
 const footerMedia=matchMedia('(max-width: 640px)');
 const refreshFooters=()=>document.querySelectorAll('.bs-footer-links').forEach(d=>{d.open=!footerMedia.matches;d.querySelector('summary').tabIndex=footerMedia.matches?0:-1;});
 footerMedia.addEventListener('change',refreshFooters);refreshFooters();
})();

(()=>{
 if(!document.body.classList.contains('wa-page'))return;
 const key='nov-wholesale-application-retry-v1';
 const success=document.querySelector('[data-wa-success]');
 const clearDraft=()=>{try{sessionStorage.removeItem(key);}catch{}};
 if(success){clearDraft();success.focus({preventScroll:true});return;}
 const form=document.getElementById('NOVApplication-wholesale');
 if(!form)return;
 const fields=[...form.elements].filter(field=>field.name?.startsWith('contact[')&&field.type!=='hidden');
 const errors=form.querySelector('[data-wa-errors]');
 if(errors){
  try{
   const saved=JSON.parse(sessionStorage.getItem(key)||'null');
   if(saved&&Date.now()-saved.time<1800000&&Array.isArray(saved.fields)){
    saved.fields.forEach(savedField=>{
     const field=fields.find(input=>input.name===savedField.name);
     if(!field)return;
     if(field.type==='checkbox')field.checked=Boolean(savedField.checked);
     else if(typeof savedField.value==='string')field.value=savedField.value;
    });
   }
  }catch{}
  clearDraft();errors.focus({preventScroll:true});
 }else clearDraft();
 const supply=form.querySelector('#wa-supply');
 const address=form.querySelector('#wa-address');
 const addressField=form.querySelector('#wa-address-field');
 const updateAddress=()=>{const delivery=supply.value==='Delivery';addressField.hidden=!delivery;address.disabled=!delivery;};
 supply.addEventListener('change',updateAddress);updateAddress();
 const requirements=form.querySelector('#wa-requirements');
 const product=new URLSearchParams(location.search).get('product');
 if(product&&!requirements.value.trim())requirements.value=product.slice(0,250);
 form.addEventListener('submit',()=>{
  if(!form.checkValidity())return;
  try{sessionStorage.setItem(key,JSON.stringify({time:Date.now(),fields:fields.map(field=>({name:field.name,value:field.value,checked:field.checked}))}));}catch{}
 });
})();

